<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.extruders')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ToolExtruderForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ToolExtruderForm from '../../components/toolextruder/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ToolExtruder';

const { mapFields } = createHelpers({
  getterType: 'toolextruder/getField',
  mutationType: 'toolextruder/updateField'
});

export default {
  name: 'ToolExtruderCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ToolExtruderForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('toolextruder', ['create', 'reset'])
  }
};
</script>
